import { render, staticRenderFns } from "./BgColumnWrapper.vue?vue&type=template&id=08903ae4"
import script from "./BgColumnWrapper.vue?vue&type=script&lang=js"
export * from "./BgColumnWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports